/* eslint-disable camelcase */
import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { userInfoSelector } from 'redux/custom-selector';
import { PlanDetailMenu } from './planDetailMenu';
import { PlanDetailsExpiredMenu } from './planDetailsExpiredMenu';
import { PlanCancelScheduledMenu } from './planCancelScheduledMenu';
import { PlanPaymentDeclinedMenu } from './planPaymentDeclinedMenu';
import { PlanCancelledMenu } from './planCancelledMenu';
// import { PlanPaymentDueMenu } from './planPaymentDueMenu';
import { NonPaymentPlanCancelledMenu } from './nonPaymentPlanCancelledMenu';
import { apiStatus } from 'constants/api';
import moment from 'moment';
import { AVAILABLE_SECONDARY_PLAN, PricingPlan, SECONDARY_PLAN_LIST } from 'constants/pricingPlan';
import { Box, Fade, Paper, Tab, Tabs } from '@material-ui/core';
import { a11yProps, planExpireTypeDisplay } from 'lib/common-function';
import { useStyles } from './style';

const PlanDetailsMenu = (props) => {
  const { isPlanExpired, isPlanMenuOpen, setPlanMenuOption, planName } = props;
  const { UserInfo } = useSelector(userInfoSelector, shallowEqual);
  const {
    subscriptionStatus = '',
    isPaymentFailed = null,
    is_payment_due_or_auto_collection_off: { auto_collection = '', amount_due = 0 },
    is_secondary_plans_present = false, secondary_plans_details = [], is_media_plus_enabled = 0
  } = UserInfo;
  const { planDropdown } = useStyles();
  const [selectedTabType, setSelectedTabType] = useState(SECONDARY_PLAN_LIST.includes(UserInfo.planName) ? 1 : 0)

  const handleChange = (_, newValue) => {
    setSelectedTabType(newValue);
  };


  return (
    <>
      {isPlanMenuOpen ? <Fade in={isPlanMenuOpen}>
        <Box
          position="absolute"
          className={`${planDropdown} hasTip`}
          width={380}
          right="-20%"
          zIndex={5}
          mt={3}
          mb={1.2}>
          <Paper elevation={2}>
            {is_secondary_plans_present && is_media_plus_enabled ?
              <Tabs
                variant="fullWidth"
                className="tabsWrap"
                value={selectedTabType}
                onChange={handleChange}
                indicatorColor="primary"
                aria-label="Plans Tabs">
                <Tab
                  label={planExpireTypeDisplay(UserInfo)}
                  value={0}
                  {...a11yProps(planExpireTypeDisplay(UserInfo))}
                />
                <Tab
                  label="Media+"
                  value={1}
                  {...a11yProps('MEDIA_PLUS')}
                />
              </Tabs>
              : null}

            {selectedTabType === 0 ? <>
              {isPlanExpired ? (
                <PlanDetailsExpiredMenu
                  isPlanMenuOpen={isPlanMenuOpen}
                  setPlanMenuOption={setPlanMenuOption}
                  isPlanExpired={isPlanExpired}
                />
              ) : subscriptionStatus === apiStatus.CANCEL_SCHEDULED &&
                // Check if Current Day lies between subscribtion End Date -15 days and  subscribtion End Date
                moment(new Date()).isBetween(
                  new Date(
                    parseInt(UserInfo.subscription_end_date_milli) - 15 * 24 * 60 * 60 * 1000
                  ).getTime(), // Subscribtion End Date -15 days
                  parseInt(UserInfo.subscription_end_date_milli) // Subscribtion End Date
                ) ? (
                // <PlanCancelScheduledMenu
                //   setPlanMenuOption={setPlanMenuOption}
                //   isPlanExpired={isPlanExpired}
                // />
                <PlanDetailMenu
                  isPlanMenuOpen={isPlanMenuOpen}
                  setPlanMenuOption={setPlanMenuOption}
                  subscriptionStatus={planName}
                  selectedTabType={selectedTabType}
                />
              ) : subscriptionStatus === apiStatus.ACTIVE && isPaymentFailed === 1 ? (
                <PlanPaymentDeclinedMenu
                  isPlanMenuOpen={isPlanMenuOpen}
                  setPlanMenuOption={setPlanMenuOption}
                  isPlanExpired={isPlanExpired}
                />
              ) : subscriptionStatus === apiStatus.CANCELLED && isPaymentFailed === 0 ? (
                <PlanCancelledMenu isPlanMenuOpen={isPlanMenuOpen} setPlanMenuOption={setPlanMenuOption} />
              ) : subscriptionStatus === apiStatus.CANCELLED && isPaymentFailed === 1 ? (
                <NonPaymentPlanCancelledMenu
                  isPlanMenuOpen={isPlanMenuOpen}
                  setPlanMenuOption={setPlanMenuOption}
                />
              ) : (
                <PlanDetailMenu
                  isPlanMenuOpen={isPlanMenuOpen}
                  setPlanMenuOption={setPlanMenuOption}
                  subscriptionStatus={planName}
                  selectedTabType={selectedTabType}
                />
              )}
            </> :
              <PlanDetailMenu
                setPlanMenuOption={setPlanMenuOption}
                subscriptionStatus={planName}
                selectedTabType={selectedTabType}
              />}
          </Paper>
        </Box>
      </Fade> : null}
      {/* {!isPlanExpired &&
        UserInfo.is_payment_due_or_auto_collection_off !== undefined &&
        auto_collection === 'off' &&
        amount_due > 0 &&
        !(
          UserInfo.planName === PricingPlan.WEBINAR ||
          UserInfo.planName === PricingPlan.DIGITAL_EVENTS ||
          UserInfo.planName === PricingPlan.ALL_IN
        ) ? (
        <PlanPaymentDueMenu isPlanMenuOpen={isPlanMenuOpen} />
      ) : (
        false
      )} */}
    </>
  );
};

export default PlanDetailsMenu;
